module.exports = __webpack_public_path__ + "media/app/assets/imgs/exchange/follow_confirmed-9c0de92b1b3532497ff02c63b5486318.png";